import script from "./SelectBoxInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBoxInput.vue?vue&type=script&setup=true&lang=js"

import "./SelectBoxInput.vue?vue&type=style&index=0&id=435e9bc8&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-435e9bc8"]])

export default __exports__